<template>
  <tml-floating-container class="p-4 h-full" width="400px" max-width="100%">
    <tml-logo class="mb-12" height="5rem" center />
    <tml-form form-name="login" class="w-full">
      <tml-input
        v-model="password"
        class="mb-6"
        placeholder="Access Code"
        type="password"
        field-name="password"
        :validation-rules="{
          required: true,
        }"
        @on-submit="onLogin"
      />
      <tml-button
        primary
        class="w-full mb-2"
        text="Login"
        :loading="loading"
        @click="onLogin"
      />
      <p class="center">
        <small>
          If this is your store, you can
          <template v-if="isTeemillPaymentProcessor">
            <tml-anchor
              href="https://teemill.com/settings/#passwordProtect"
              target="_blank"
            >
              login
            </tml-anchor>
          </template>
          <template v-else> login into your platform</template>
          to preview your store
        </small>
      </p>
    </tml-form>
  </tml-floating-container>
</template>

<script>
import {formatUrl} from '@teemill/common/helpers';
import {snackbar} from '@teemill/common/services';
import {usePaymentProcessorStore} from '@teemill/common/vuex';

import {store} from '../../services';
import {useHead} from '@vueuse/head';
import {noIndex} from '@teemill/common/assets/meta/noIndex';

export default {
  name: 'LoginPage',

  data() {
    return {
      loading: false,

      password: null,
    };
  },

  computed: {
    isTeemillPaymentProcessor() {
      return (
        usePaymentProcessorStore().getter('paymentProcessorType') === 'teemill'
      );
    },
  },
  created() {
    useHead(noIndex);
  },

  methods: {
    onLogin() {
      this.loading = true;

      this.axios
        .post(formatUrl('/omnis/v3/division/login/'), {
          division: this.$store.state.subdomain.division,
          password: this.password,
        })
        .success(data => {
          store.commit('subdomain/install', data);

          this.$router.push({name: 'home'});
        })
        .any(() => {
          snackbar.error('Oops... Like like the access code is incorrect');
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
